<template>
  <div>
    <Tab />
    <v-app>
      <v-app-bar
        app
        :style="`background-color: ${headerBGColor} !important;${widthHeader}`"
        :clipped-left="clipped"
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-icon @click="changeMenu" class="buttonMenu">fas fa-bars</v-icon>
        <a :href="sitesAppRoot" class="centerXsScreen">
          <img :src="url_image" alt="LiveLaps" border="0" class="logo" />
        </a>
        <v-spacer v-if="windowWidth >= 600"></v-spacer>
        <Logout style="margin-right: 7% !important" />
        <LanguageSwitcher />
      </v-app-bar>
      <v-navigation-drawer
        absolute
        app
        v-model="drawerMenu"
        :clipped="clipped"
        enable-resize-watcher
        height="100% !important"
        style="max-height: calc(100% - 70px);"
      >
        <v-list nav dense>
          <v-list-item-group active-class="text--accent-4">
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="imageUserUrl" @error="errorImageEvent"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ $t("dashboard.title_user") }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ fullName }} <br />
                  {{ $t("livelaps_id") }}: {{ livelapsId }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <div v-for="item in dynamicMenuItems" :key="item.title">
              <v-list-item link :to="{ name: item.routeName }">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-title>
                  {{ $t(item.title) }}
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-list-item-group>

          <!-- Menu Items -->
          <v-list-group
            v-for="item in filteredItems"
            :key="item.title"
            append-icon=""
            no-action
            :class="`menuMain ${nameRoute == item.routeName ? 'active-custom' : 'no-active-custom' }`"
          >
            <v-list-item
              slot="activator"
              v-if="item.items.length <= 0"
              @click="($event) => actionClickMenu($event, item.routeName)"
              class="opli"
              link
            >
              <v-list-item-icon>
                <v-icon>{{item.action}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-else slot="activator"  class="opli" link>
              <v-list-item-icon>
                <v-icon>{{item.action}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                v-if="item.items.length > 0"
                class="v-list-item__icon v-list-group__header__append-icon mb-0"
              >
                <v-icon>fas fa-chevron-down</v-icon>
              </v-list-item-action>
            </v-list-item>
            <div v-if="item.items.length > 0">
              <v-list-item-group
                v-for="subitem in item.items"
                :key="subitem.title"
                ripple
                @click="close"
                :class="`borderb ${nameRoute == subitem.routeName ? 'active-custom' : 'no-active-custom' }`"
              >
                <v-list-item
                  v-if="(subitem.routeName != 'EventWaiver' || subitem.routeName == 'EventWaiver' && !hideWaiversMenu)"
                  class="pl64"
                  @click="($event) => actionClickMenu($event,subitem.routeName)"
                >
                  <v-list-item-icon>
                    <v-icon>{{subitem.action}}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{$t(subitem.title)}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </div>
          </v-list-group>
          <v-list-group
            append-icon=""
            no-action
            class="menuMain"
            :style="activeStyle"
          >
            <v-list-item slot="activator" class="opli" link @click="logout">
              <v-list-item-icon>
                <v-icon>fa fa-sign-out-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("layouts.login.logout")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <div style="height: 100px;"></div>
        </v-list>
      </v-navigation-drawer>
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto overflow-x-hidden"
        :max-height="windowHeight"
      >
        <v-main
          id="main1"
          :style="`${widthMain}; min-height: ${windowHeight}px;`"
        >
          <div class="divLeftBorder">
            <v-alert
              class="alertUnpaid showNot"
              dense
              icon="fas fa-exclamation-triangle"
              style="position: absolute; top: -64px; margin: auto 0;"
            >
              <p class="mb-0">{{ $t("dashboard.unpaid") }}</p>
              <a href="#" @click="link()">
                {{ $tc("dashboard.unpaidlink") }}
              </a>
            </v-alert>
            <Breadcrumb @breadCrumbStep1="breadCrumbStep1" />
            <v-progress-linear
              :active="loadingStep"
              :indeterminate="loadingStep"
              absolute
              :color="headerBGColor"
            ></v-progress-linear>
            <div
              :class="
                `container-fluid ${
                  loadMarginT ? 'mt-4' : loadingStep ? 'mt-1' : 'mt-0'
                } pb-16`
              "
            >
              <router-view
                ref="componentRouterView"
                @userName="getUserName"
                @imageUser="getImageUser"
                @titlePage="getTitlePage"
                @dynamicMenuItems="getDynamicMenuItems"
                @resizeIframe="resizeMount"
                @changeLoadingStep="changeLoadingStep"
                @changeLoadMarginTop="changeLoadMarginTop"
              ></router-view>
            </div>
          </div>
        </v-main>
      </v-sheet>
      <v-footer app style="padding: 0px;"></v-footer>
    </v-app>
    <div id="framefixerextreme" style="height: 0 !important;">
      <v-app id="inspire" style="height: 0 !important;">
        <v-row justify="center">
          <v-dialog v-model="waiverModal" persistent width="unset">
            <v-card>
              <v-card-text class="px-sm-6 px-0">
                <WaiverEvent :waivers="waiverE" @nextSignItem="nextSignItem" />
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="waiverOrgModal" persistent width="unset">
            <v-card>
              <v-card-text class="px-sm-6 px-0">
                <WaiverOrg
                  :waivers="waiverOrg"
                  :relationshipByMinor="pgByMinor"
                  :blockedMinorIds="pgBlockedMinors"
                  @nextSignItem="nextSignOrgItem"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-app>
    </div>
    <!-- AMA Waiver Bypass v2 — the relationship prompt runs before the
         dashboard waiver popup opens. We collect a relationship for every
         unsigned minor waiver sequentially, then the waiver dialog opens
         with the captured relationships injected so each sign request
         carries the correct signatoryRelationship. -->
    <ParentGuardianDialog
      v-model="pgDialogOpen"
      :adultId="pgAdultId"
      :minor="pgDialogMinor"
      :canLogout="true"
      @confirmed="onPgConfirmed"
      @blocked="onPgBlocked"
      @logout="logout"
    />
  </div>
</template>

<script>
import LanguageSwitcher from "./LanguageSwitcher";
import Logout from "./Logout";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import PaymentService from "../../services/PaymentService";
import LoginService from "@/services/LoginService";
import APIService from "@/services/APIService";
import EventWaiverService from "@/services/EventWaiverService";
import WaiverEvent from "@/components/waiver/WaiverEvent";
import WaiverOrg from "@/components/waiverOrganization/WaiverOrg";
import ParentGuardianDialog from "@/components/memberRegistration/ParentGuardianDialog.vue";
import Tab from '@/components/Tab.vue';
import { mapState, mapGetters } from "vuex";
import {
  VApp,
  VAppBar,
  VFooter,
  VSheet,
  VImg,
  VMain,
  VListItemTitle,
  VListItemContent,
  VNavigationDrawer,
  VDivider,
  VAlert,
  VDialog,
  VCardText,
  VCard,
  VRow,
  VList,
  VSpacer,
  VListItemSubtitle,
  VListGroup,
  VIcon,
  VListItem,
  VListItemAction,
  VListItemAvatar,
  VListItemGroup,
  VListItemIcon,
  VProgressLinear,
} from "vuetify/lib";
import LocalStorageService from "../../services/LocalStorageService";
import WaiverService from '../../services/WaiverService';

export default {
  name: "Main",
  components: {
    LanguageSwitcher,
    Logout,
    Breadcrumb,
    VApp,
    VAppBar,
    VFooter,
    VSheet,
    VImg,
    VMain,
    VNavigationDrawer,
    VDivider,
    VAlert,
    VList,
    VListItemSubtitle,
    VListGroup,
    VSpacer,
    VListItemContent,
    VIcon,
    VListItem,
    VListItemAction,
    VListItemAvatar,
    VListItemGroup,
    VListItemIcon,
    VListItemTitle,
    VProgressLinear,
    VDialog,
    VCardText,
    VCard,
    VRow,
    WaiverEvent,
    WaiverOrg,
    ParentGuardianDialog,
    Tab
  },
  data: () => ({
    imageUser: null,
    drawerMenu: true,
    widthHeader: "",
    widthMain: "",
    clipped: false,
    titlePage: null,
    openmenu: null,
    dynamicMenuItems: [],
    waiverModal: false,
    waiverOrgModal: false,
    waiverE: {},
    waiverOrg: {},
    // AMA Waiver Bypass v2 — relationship prompt state for the dashboard
    // popup flow. Captured relationships are merged into each minor
    // waiver before the waiver dialog opens; blocked minors (Other) are
    // filtered out server-side when the sign request is rejected.
    pgDialogOpen: false,
    pgDialogMinor: null,
    pgByMinor: {},
    pgBlockedMinors: [],
    menuClass: "",
    mleft: "",
    items: [
      {
        action: "fa fa-home",
        title: "dashboard.title",
        active: false,
        name: "dashboard",
        routeName: "Dashboard",
        items: [],
      },
      {
        action: "fa fa-calendar-alt",
        title: "layouts.main.events",
        active: false,
        name: "events",
        routeName: "",
        items: [
          {
            title: "registerEventLegacy.title",
            routeName: "RegisterEventLegacy",
            action: "fa fa-calendar-day",
          },
          {
            title: "yourRegistration.title",
            routeName: "YourRegistration",
            action: "fa fa-address-card",
          },
          {
            title: "incompleteRegistration.title",
            routeName: "UnPaidRegistrationDashboard",
            action: "fa fa-money-check",
          },
          {
            title: "registeredParticipants.title",
            routeName: "RegisteredParticipants",
            action: "fa fa-user-check",
          },
          {
            title: "eventWaiver.title",
            routeName: "EventWaiver",
            action: "fa fa-file-signature",
          },
        ],
        subItemActive: null,
      },
      {
        action: "fas fa-id-card-alt",
        title: "layouts.main.membership",
        routeName: "Membership",
        active: false,
        name: "membership",
        items: [
          {
            title: "layouts.main.member-registration",
            routeName: "MemberRegistration",
            action: "fa fa-portrait",
          },
          {
            title: "layouts.main.registered-members",
            routeName: "RegisteredMembers",
            action: "fa fa-users",
          },
          {
            title: "layouts.main.your-membership",
            routeName: "Membership",
            action: "fa fa-address-card",
          },
          {
            title: "layouts.main.membership_classes",
            routeName: "MembershipClasses",
            action: "fa fa-flag",
          },
          {
            title: "layouts.main.membership-waivers",
            routeName: "MembershipWaivers",
            action: "fa fa-file-signature",
          },
        ],
        subItemActive: null,
      },
      {
        action: "fas fa-trophy",
        title: "results.title",
        active: false,
        name: "results",
        routeName: "",
        items: [
          {
            title: "layouts.main.participants-results",
            routeName: "Results",
            action: "fa fa-medal",
          },
          {
            title: "layouts.main.all-results",
            routeName: "ResultsDetails",
            action: "fa fa-flag-checkered",
          },
        ],
        subItemActive: null,
      },
      {
        action: "fas fa-clipboard-check",
        title: "authorization.title",
        active: false,
        name: "authorization",
        routeName: "Authorization",
        items: [],
      },
      {
        action: "fa fa-users",
        title: "riders.title",
        active: false,
        name: "riders",
        routeName: "Riders",
        items: [],
      },
      {
        action: "fa fa-user-friends",
        title: "spectators.title",
        active: false,
        name: "spectators",
        routeName: "Spectators",
        items: [],
      },
      {
        action: "fa fa-user-circle",
        title: "profile.title",
        active: false,
        name: "profile",
        routeName: "Profile",
        items: [],
      },
      {
        action: "fas fa-ambulance",
        title: "emergencyContact.title",
        routeName: "Emergency",
        name: "emergencyContact",
        items: [
          {
            title: "emergencyContact.contact",
            routeName: "EmergencyContact",
            action: "fa fa-address-card",
          },
          {
            title: "emergencyContact.medical_information",
            routeName: "EmergencyInfo",
            action: "fa fa-address-card",
          },
        ],
        active: false,
        subItemActive: null,
      },
      {
        action: "fa fa-motorcycle",
        title: "vehicles.title",
        routeName: "Vehicles",
        active: false,
        name: "vehicles",
        items: [],
      },
      {
        action: "fas fa-user-tag",
        title: "transponder.title",
        routeName: "Transponder",
        active: false,
        name: "transponder",
        items: [],
      },
      {
        action: "fas fa-hands-helping",
        title: "sponsors.title",
        routeName: "Sponsors",
        active: false,
        name: "sponsors",
        items: [],
      },
      {
        action: "fa fa-share-alt-square",
        title: "social.title",
        routeName: "Social",
        active: false,
        name: "social",
        items: [],
      },
      {
        action: "fa fa-comment-dollar",
        title: "dashboard.billing",
        active: false,
        name: "billing",
        routeName: "Billing",
        items: [],
      },
    ],
    errorImage: require("@/assets/images/partPlaceholder.jpg"),
    hasUnsignedWaiver: false,
    hasUnpaidRegistrations: false,
    userName: "",
    windowHeight: 0,
    loadingStep: true,
    loadMarginT: true,
    iframePages: [
      "cancelregistrationiframe",
      "CompleteYourRegistration",
      "EventRegistration",
      "JoinedClub",
      "JoinedClubPP",
    ],
    excludePagesProcessRegister: [
      "UnPaidRegistrationDashboard",
      "PaymentDashboard",
      "UnPaidRegistration",
      "Payment",
      "canceled_registration",
      "cancelregistrationiframe",
      "CompleteYourRegistration",
    ],
    hideWaiversMenu: false,
    nameCompActive: null
  }),
  methods: {
    /**
     * AMA Waiver Bypass v2 — pre-check flow for the dashboard popup.
     * Before the waiver dialog opens we collect a relationship for
     * every unsigned minor waiver. Runs recursively: on each confirm
     * or block we re-enter and look for the next minor that still
     * needs a relationship, then open the waiver dialog once none
     * remain. Adult-only waiver sets skip straight to the dialog.
     */
    openWaiverOrgFlow() {
      if (!Array.isArray(this.waiverOrg) || this.waiverOrg.length === 0) {
        this.waiverOrgModal = false;
        return;
      }
      const next = this._firstMinorNeedingRelationship();
      if (next) {
        this.pgDialogMinor = {
          id: Number(next.participantId || next.fkUserId || 0),
          fName: next.participantName || '',
          lName: next.participantLastname || ''
        };
        this.pgDialogOpen = true;
        return;
      }
      this._applyCapturedRelationshipsToWaivers();
      this.waiverOrgModal = true;
    },
    _isMinorWaiver(w) {
      if (!w || !w.participantDateOfBirth) return false;
      const dob = new Date(w.participantDateOfBirth);
      if (isNaN(dob.getTime())) return false;
      const now = new Date();
      const ageYears = (now.getTime() - dob.getTime()) / (365.25 * 24 * 3600 * 1000);
      return ageYears < 18;
    },
    _firstMinorNeedingRelationship() {
      if (!Array.isArray(this.waiverOrg)) return null;
      for (const w of this.waiverOrg) {
        if (!w) continue;
        if (w.waiverStatus === 'Signed') continue;
        if (!this._isMinorWaiver(w)) continue;
        const minorId = Number(w.participantId || w.fkUserId || 0);
        if (!minorId) continue;
        if (this.pgByMinor[minorId]) continue;
        if (this.pgBlockedMinors.includes(minorId)) continue;
        return w;
      }
      return null;
    },
    _applyCapturedRelationshipsToWaivers() {
      if (!Array.isArray(this.waiverOrg)) return;
      for (const w of this.waiverOrg) {
        if (!w) continue;
        const minorId = Number(w.participantId || w.fkUserId || 0);
        if (!minorId) continue;
        const rel = this.pgByMinor[minorId];
        if (rel) {
          this.$set(w, 'signatoryRelationship', rel);
        }
      }
    },
    onPgConfirmed(payload) {
      if (payload && payload.minor && payload.relationshipCode) {
        const minorId = Number(payload.minor.id);
        if (minorId) {
          this.$set(this.pgByMinor, minorId, payload.relationshipCode);
        }
      }
      this.pgDialogOpen = false;
      this.pgDialogMinor = null;
      this.$nextTick(() => this.openWaiverOrgFlow());
    },
    onPgBlocked(payload) {
      if (payload && payload.minor && payload.minor.id) {
        const minorId = Number(payload.minor.id);
        if (minorId && !this.pgBlockedMinors.includes(minorId)) {
          this.pgBlockedMinors.push(minorId);
        }
      }
      this.pgDialogOpen = false;
      this.pgDialogMinor = null;
      this.$nextTick(() => this.openWaiverOrgFlow());
    },
    nextSignOrgItem() {
      this.waiverOrgModal = false;
      location.reload();
    },
    nextSignItem() {
      this.waiverModal = false;
      location.reload();
    },
    errorImageEvent() {
      this.imageUser = this.errorImage;
    },
    changeMenu() {
      this.widthHeader = "";
      this.widthMain = "";
      if (this.drawerMenu) {
        this.widthHeader = "left:0px !important;";
        this.widthMain = "padding-left: 0px !important;";
      }
      this.drawerMenu = !this.drawerMenu;
    },
    close() {},
    link() {
      this.$router.push({
        path: "unPaidRegistrationDashboard",
      });
    },
    getTitlePage(titlePage) {
      this.titlePage = titlePage;
    },
    getImageUser(imageUser) {
      this.imageUser = imageUser;
    },
    getUserName(userName) {
      this.userName = userName;
    },
    getDynamicMenuItems(dynamicMenuItems) {
      this.dynamicMenuItems = dynamicMenuItems ? dynamicMenuItems : [];
    },
    getOptionsMenu(val) {
      let band = false;
      this.items.forEach(item => {
        if (item.name.toLowerCase() == val.toLowerCase()) {
          item.active = true;
          band = true;
        } else if (item.items.length > 0) {
          item.items.forEach(subItem => {
            if (subItem.routeName.toLowerCase() == val.toLowerCase()) {
              item.active = true;
              subItem.active = true;
              band = true;
            }
          });
        }
      });
      if (!band && this.$route.meta.openMenu) {
        this.getOptionsMenu(this.$route.meta.openMenu);
      }
    },
    async hasConfiguredWaivers()
    {
      if(this.defaultPromoter){
        await APIService.fetch(
          {
            path: `/promoters/${this.defaultPromoter}/hasConfiguredWaivers`,
          }
        ).then((resp) => {
          if (resp.data.success) {
            const message = resp.data.message;
            this.hideWaiversMenu = !message;
            this.$store.dispatch("setHideWaiversMenuAction", this.hideWaiversMenu);
            
            if(this.hideWaiversMenu && (this.$route.path == '/eventWaivers' || this.$route.path == 'eventWaivers'))
            {
              this.$router.push('dashboard')
            }
          }
        });
      }
    },
    hasUnsignedWaiver_() {
      LoginService.hasWaiverToSign().then((response) => {
        if (response && response.data && response.data.success == 1 && response.data.message != false && response.data.message != null) {
          this.hasUnsignedWaiver = response.data.message;

          if(this.hasUnsignedWaiver.includes('event')){
            this.$store.dispatch("setUnsignedWaiver", this.hasUnsignedWaiver);
            const variable = this.hasUnsignedWaiver.split("-");
            EventWaiverService.generateWaiverForEventWaiverSigned(
              variable[1]
            ).then((resp) => {
              if (resp.data.success) {
                this.waiverE = resp.data.message;
                this.waiverModal = true;
              }
            });
          }else if (this.hasUnsignedWaiver == "adult") {
            WaiverService.getOrganizationsWaiwers().then((resp) => {
              if (resp.data.success) {
                if(resp.data.message.length > 0 && resp.data.message[0].isOld){
                  window.location.href = this.$store.getters.env.get("VUE_APP_DEV_API_HOST") + "/admin/waiverESign";
                }else{
                  this.waiverOrg = resp.data.message;
                  this.openWaiverOrgFlow();
                }
              }
            });
          } else if (this.hasUnsignedWaiver == "minor") {
            WaiverService.getOrganizationsWaiwers().then((resp) => {
              if (resp.data.success) {
                if(resp.data.message.length > 0 && resp.data.message[0].isOld){
                  window.location.href = this.$store.getters.env.get("VUE_APP_DEV_API_HOST") + "/admin/waiverMinorESign";
                }else{
                  this.waiverOrg = resp.data.message;
                  this.openWaiverOrgFlow();
                }
              }
            });
          }
        } else {
          this.hasUnsignedWaiver = false;
          this.$store.dispatch("setUnsignedWaiver", this.hasUnsignedWaiver);
        }
      }).catch(() => {});
    },
    hasUnpaidRegistrations_() {
      PaymentService.hasUnpaidRegistrations().then((response) => {
        if (response.data.success == 1) {
          this.hasUnpaidRegistrations = response.data.message;
          this.$store.dispatch(
            "setUnPaidRegistrationAction",
            this.hasUnpaidRegistrations
          );
          if (
            this.hasUnpaidRegistrations &&
            this.$route.name != "UnPaidRegistrationDashboard" &&
              this.$route.name != "PaymentDashboard" &&
              this.$route.name != "canceled_registration"
          ) {
            this.showAlert();
          } else {
            if (document.querySelector(".alertUnpaid")) {
              document.querySelector(".alertUnpaid").classList.add("showNot");
            }
          }
        } else {
          this.hasUnpaidRegistrations = false;
          this.$store.dispatch(
            "setUnPaidRegistrationAction",
            this.hasUnpaidRegistrations
          );
        }
      });
    },
    resetAlert() {
      var elem2 = document.getElementById("scrolling-techniques-7");
      elem2.scrollTop = 0;

      document.querySelector(".alertUnpaid").classList.remove("showAlert");
      document.querySelector(".alertUnpaid").classList.add("showNot");
    },
    showAlert() {
      document
        .querySelector(".alertUnpaid")
        .setAttribute("style", "background: " + this.bgAlertColor);
      document
        .querySelector(".v-alert__icon")
        .setAttribute("style", "color:" + this.iconAlertColor);
      document.querySelector(".alertUnpaid").classList.remove("showNot");
      document.querySelector(".alertUnpaid").classList.add("showAlert");
    },
    clearSessionState() {
      this.$store.commit('setUserName', '');
      this.$store.commit('setUserId', '');
      this.$store.commit('setUser', null);
      this.$store.commit('setHasUnsignedWaiver', null);
      this.$store.commit('setAge18', false);
      this.$store.commit('setUnPaidRegistration', false);
      this.$store.commit('setParticipants', []);
      this.$store.commit('setParticipantsSelected', []);
      try { localStorage.removeItem('select_parts_users'); } catch(e) { /* noop */ }
    },
    async logout() {
      LoginService.logout().then(() => {
        this.clearSessionState();
        if (typeof this.oldSystem === "undefined") {
          this.$router.push({ name: 'Login' });
        } else {
          window.location.href =
            this.$store.getters.env.get("VUE_APP_DEV_API_HOST") +
            "/login?message=You20are%20logged%20out!";
        }
      }).catch(() => {
        this.clearSessionState();
        this.$router.push({ name: 'Login' });
      });
    },
    resizeMount() {
      this.windowHeight = window.innerHeight;
      const elements = document.getElementsByClassName("iframeSel");
      if (elements.length > 0) {
        const headerHeight = document.getElementsByTagName("header")[0]
          .clientHeight;
        const breadcrumbHeight = document.getElementById("breadcrumb")
          .clientHeight;
        const headerIframe =
          this.windowHeight - headerHeight - breadcrumbHeight;
        elements[0].style.minHeight = `${headerIframe}px`;
        elements[0].style.maxHeight = `${headerIframe}px`;
      }
    },
    modeRespMenu() {
      const ancho = window.innerWidth;
      if (ancho <= 1260) {
        this.drawerMenu = false;
      }
    },
    breadCrumbStep1() {
      if (
        this.$refs.componentRouterView.$route.name == "RegisterEventLegacy" ||
        this.$refs.componentRouterView.$route.name ==
          "MembershipRegistration" ||
        this.$refs.componentRouterView.$route.name == "EventRegistration"
      ) {
        this.$refs.componentRouterView.breadCrumbStep1();
      }
    },
    changeLoadingStep(newValue) {
      this.loadingStep = newValue;
    },
    changeLoadMarginTop(newValue) {
      this.loadMarginT = newValue;
    },
    preOpenMenuAll(link) {
      this.getOptionsMenu(link);
    },
    actionClickMenu($event, nameComp) {
      $event.preventDefault();
      this.nameCompActive = nameComp;
      if(nameComp == 'RegisterEventLegacy') {
        LocalStorageService.removeItem('registration_legacy');
        LocalStorageService.setItem('active_event_registration', false);
      }
      if(this.$route.name == 'MemberRegistrationComplete') {
        const componentRouterView = this.$refs.componentRouterView;
        if(componentRouterView) {
          componentRouterView.refresStep();
        }
        this.$router.push({ name: 'MemberRegistration' });
      }else if(this.$route.name != nameComp) {
        this.$router.push({ name: nameComp });
      } else if(nameComp == 'RegisterEventLegacy' || nameComp == 'MemberRegistration') {
        const componentRouterView = this.$refs.componentRouterView;
        if(componentRouterView) {
          componentRouterView.refresStep();
        }
      } 
      
      if(nameComp == 'MemberRegistration') {
        const memberReg = LocalStorageService.getItem('member_reg');
        if(memberReg){
          LocalStorageService.removeItem('member_reg');
        }
      }
    }, 
    addResetScrolling() {
        let scrollingTechniques = document.getElementById("scrolling-techniques-7");
        if(scrollingTechniques) {
          scrollingTechniques.scrollTop = 0;
          scrollingTechniques.classList.remove("overflow-y-hidden");
          scrollingTechniques.classList.add("overflow-y-auto");
        }
    },
    removeResetScrolling() {
        let scrollingTechniques = document.getElementById("scrolling-techniques-7");
        if(scrollingTechniques) {
          scrollingTechniques.scrollTop = 0;
          scrollingTechniques.classList.remove("overflow-y-auto");
          scrollingTechniques.classList.add("overflow-y-hidden");
        }
    },
    resizeMain() {
        this.windowHeight = window.innerHeight;
        const elements = document.getElementsByClassName("iframeSel");
        if (elements.length > 0) {
          const headerHeight = document.getElementsByTagName("header")[0]
            .clientHeight;
          const breadcrumbHeight = document.getElementById("breadcrumb")
            .clientHeight;
          const headerIframe =
            this.windowHeight - headerHeight - breadcrumbHeight;
          elements[0].style.minHeight = `${headerIframe}px`;
          elements[0].style.maxHeight = `${headerIframe}px`;
        }
    },
    redirectDashboard() {
      if(this.hideMembershipRegistration == 1 || this.hideMembershipRegistration === '1') {
        switch(this.nameRoute) {
          case 'Membership':
            this.$router.push('dashboard');
            break;

          case 'MembershipRegistration':
            this.$router.push('dashboard');
            break;

          case 'MemberRegistration':
            this.$router.push('dashboard');
            break;
        }
      }
    }
  },
  created: function() 
  {
    if(this.$route.name != 'logout')
    {
      this.hasConfiguredWaivers()
    }

    if (
      this.$route.name != "UnPaidRegistrationDashboard" &&
      this.$route.name != "PaymentDashboard" &&
      this.$route.name != "UnPaidRegistration" &&
      this.$route.name != "Payment" &&
      this.$route.name != "canceled_registration" &&
      this.$route.name != "cancelregistrationiframe" &&
      this.$route.name != "CompleteYourRegistration"
    ) {
      this.hasUnpaidRegistrations_();
      if (this.$route.name != "logout") {
        this.hasUnsignedWaiver_();
      }
    } else if (this.$route.name != "logout") {
      this.hasUnsignedWaiver_();
    } else if (
      this.$route.name == "EventRegistration" &&
      this.$route.name == "JoinedClub" &&
      this.$route.name == "JoinedClubPP" &&
      this.$route.name == "MembershipRegistration"
    ) {
      const parent = this;
      const onLoad = function() {
        parent.hasUnpaidRegistrations_();
      };
      document
        .getElementsByClassName("iframeSel")
        .addEventListener("load", onLoad, true);
    }
    this.modeRespMenu();
  },
  updated() {
    this.windowHeight = window.innerHeight;
  },
  mounted() 
  {
    this.resizeMount();
    this.nameCompActive = this.$route.name;
    if (!this.participants || this.participants.length == 0) {
      this.$store.dispatch("setParticipantsAction");
    }
    if (this.bandIFrame) {
      this.loadMarginT = false;
      this.removeResetScrolling();
    } else {
      this.addResetScrolling();
    }
    const parent = this; //parent
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        parent.resizeMain();
        parent.$store.dispatch("setWindowWidthAction");
      });
    });
    if (this.bandForLoadingStep) {
      this.loadingStep = false;
    }
    this.preOpenMenuAll(this.$route.name);

    if(this.hideMembershipRegistration == 1 || this.hideMembershipRegistration === '1') {
      switch(this.nameRoute) {
        case 'Membership':
          this.$router.push('dashboard');
          break;

        case 'MembershipRegistration':
          this.$router.push('dashboard');
          break;

        case 'MemberRegistration':
          //this.$router.push('dashboard');
          break;
      }
    }
  },
  computed: {
    /**
     * AMA Waiver Bypass v2 — the signing adult for the dashboard popup
     * is the currently-logged-in user. Anchors the relationship pair
     * record saved from ParentGuardianDialog.
     */
    pgAdultId() {
      const sess = this.$store && this.$store.state && this.$store.state.session;
      return sess && (sess.userid || sess.userId || (sess.user && sess.user.id)) || 0;
    },
    filteredItems(){
      return this.items.filter(element => (element.title != 'layouts.main.membership' || (element.title == 'layouts.main.membership' && this.hideMembershipRegistration == '0')))
    },
    hideMembershipRegistration(){
      return this.env.get('VUE_APP_HIDE_MEMBERSHIP_REG');
    },
    activeStyle() {
      return {
        "--background-active": this.backgroundActive,
      };
    },
    ...mapState({
      unPaidRegistration(state) {
        if (!this.excludePagesProcessRegister.includes(this.$route.name)) {
          return state.session.unPaidRegistration;
        }
        return false;
      },
      session(state) {
        return state.session;
      },
      user: (state) => state.session.user,
      fullName: (state) => {
        const user = state.session.user;
        if (user) {
          return `${user.firstName} ${user.lastName}`;
        }
        return "";
      },
      livelapsId: function(state) {
        const user = state.session.user;
        if (user) {
          return user.id;
        }
        return "";
      },
      windowWidth: (state) => state.constants.windowWidth,
      participants: (state) => state.session.participants,
      headerBGColor: (state) => state.env.get("VUE_APP_HEADER_COLOR"),
      backgroundActive: (state) => state.env.get("VUE_APP_BACKGROUND_MENU_ACTIVE"),
      borderAlertColor: (state) => state.env.get("VUE_APP_BORDER_ALERT_MAIN"),
      iconAlertColor: (state) => state.env.get("VUE_APP_ICON_ALERT_MAIN"),
      bgAlertColor: (state) => state.env.get("VUE_APP_BG_ALERT_MAIN"),
      VUE_APP_LIVELAPS_HOST: (state) => state.env.get("VUE_APP_LIVELAPS_HOST")
    }),
    ...mapGetters({
      env: "env",   
      url_image: "vueAppLogoView",
      livelapsLink: "vueAppRoot",
      sitesAppRoot: "sitesAppRoot"
    }),
    defaultPromoter()
    {
      return this.env.get('VUE_APP_DEFAULT_PROMOTER');
    },
    nameRoute() {
      return this.$route.name;
    },
    objectRoute() {
      return { name: this.$route.name, path: this.$route.path, query: this.$route.query, params: this.$route.params };
    },
    imageUserUrl: {
      get() {
        let urlImage = '';
        if((this.imageUser || "").length > 0) {
          urlImage = this.imageUser;
        } else if(this.user) {
          urlImage = this.user.image;
        } else {
          urlImage = require("@/assets/images/partPlaceholder.jpg");
        }
        return urlImage;
      },
      set(value) {
        this.imageUser = value;
      }
    },
    bandIFrame() {
      return (this.$route.name == "cancelregistrationiframe" ||
              this.$route.name == "CompleteYourRegistration" ||
              this.$route.name == "EventRegistration" ||
              this.$route.name == "JoinedClub" ||
              this.$route.name == "JoinedClubPP");
    },
    bandForLoadingStep() {
      return (this.$route.name != "RegisterEventLegacy" &&
              this.$route.name != "cancelregistrationiframe" &&
              this.$route.name != "CompleteYourRegistration" &&
              this.$route.name != "EventRegistration" &&
              this.$route.name != "JoinedClub" &&
              this.$route.name != "JoinedClubPP" &&
              this.$route.name != "MembershipRegistration" && 
              this.$route.name != "MemberRegistration" &&
              this.$route.name != "MemberRegistrationComplete" &&
              this.$route.name != "MemberRegistrationWithTarget" &&
              this.$route.name != "Dashboard");
    },
    bandForPayment() {
      return (this.$route.name != "UnPaidRegistrationDashboard" &&
              this.$route.name != "PaymentDashboard" &&
              this.$route.name != "UnPaidRegistration" &&
              this.$route.name != "Payment" &&
              this.$route.name != "canceled_registration" &&
              this.$route.name != "cancelregistrationiframe" &&
              this.$route.name != "CompleteYourRegistration");
    }
  },
  watch: {
    unPaidRegistration(val) {
      if (!val) {
        this.resetAlert();
      } else {
        this.showAlert();
      }
    },
    nameRoute(val) {
      if (this.bandIFrame) {
        this.removeResetScrolling();
      } else {
        this.addResetScrolling();
      }
      this.modeRespMenu();
      if (this.bandForLoadingStep) {
        this.loadingStep = false;
      } else {
        this.loadingStep = true;
      }

      if (this.bandForPayment) {
        this.hasUnpaidRegistrations_();
        if (this.$route.name != "logout") {
          this.hasUnsignedWaiver_();
        }
      } else if (this.$route.name != "logout") {
        this.hasUnsignedWaiver_();
      } else if (this.bandIFrame) {
        const parent = this;
        const onLoad = function() {
          parent.hasUnpaidRegistrations_();
        };
        document.getElementsByClassName("iframeSel").addEventListener("load", onLoad, true);
      }
      this.preOpenMenuAll(val);
    },
    user(val) {
      if(val) {
        this.imageUser = val.image;
      }
    },
    objectRoute(val, oldVal) {
      LocalStorageService.setItem("previus_link", oldVal);
    }
  }
};
</script>

<style>
:root {
  --background-active: #ccc;
}
.showAlert {
  display: inherit;
}
.showNot {
  display: none !important;
}
html {
  overflow-y: hidden !important;
}
.v-navigation-drawer {
  background: rgb(241, 241, 241) !important;
}
nav.v-navigation-drawer.v-navigation-drawer--is-mobile.v-navigation-drawer--open {
  z-index: 10;
}
.logo {
  height: 50px;
  margin-right: 50px;
}
.pl64 {
  padding-left: 48px;
}
.v-list--dense .v-list-item .v-list-item__title {
  font-size: 14px;
}
.borderb {
  border-top: 1px solid #ccc;
}
.v-list-group {
  border-bottom: 1px solid #ccc;
}
.v-list-item-group .v-list-item--active {
  border-bottom: 1px solid #ccc;
}
.v-list--nav .v-list-item {
  border-radius: 0;
}
.v-list--nav {
  padding: 0;
}
.v-toolbar {
  color: white !important;
}
.v-list--nav .v-list-item {
  border-radius: 0 !important;
}
.v-list-group--active > .v-list-group__header .v-list-item__content {
  color: rgba(0, 0, 0, 0.87);
}
.v-list .v-list-item--active .v-icon {
  color: #45615f !important;
}
.cnone {
  display: none;
}
.cblock {
  display: block;
}
.v-list-item--link:before {
  background-color: transparent !important;
}
.v-list .v-list-item--active .v-icon {
  color: #45615f !important;
}
.menuMain .v-list .v-list-item--active .v-icon {
  color: #45615f !important;
}
.v-list-group--active > .v-list-group__header {
  background: var(--background-active) !important;
}
.v-list--nav.v-list--dense .v-list-item:not(:last-child):not(:only-child) {
  margin-bottom: 0;
}
.borderb a.v-list-item--active {
  color: #45615f !important;
  background-color: var(--background-active);
}
.borderb a {
  padding-left: 32px !important;
}
.v-list-group--active
  > .v-list-group__header
  > .v-list-group__header__append-icon
  .v-icon {
  transform: rotate(-180deg);
  color: #45615f !important;
}
.v-list-group--active
  > .v-list-group__header
  > .opli
  > .v-list-group__header__append-icon
  .v-icon {
  transform: rotate(-180deg);
  color: #45615f !important;
}
.buttonMenu {
  color: #fff !important;
  margin-right: 5px;
}
.opli {
  margin-left: -22px !important;
}
.v-toolbar {
  left: 320px !important;
}
.v-main .v-toolbar {
  left: 0 !important;
}
.v-navigation-drawer {
  width: 320px !important;
  height: 90% !important;
}
.v-main {
  padding-left: 320px !important;
}
.v-list-group__header__append-icon .v-icon {
  font-size: 14px !important;
}
.v-list-item__icon:first-child {
  margin-right: 15px !important;
  margin-left: 20px !important;
  width: 20px;
}
@media (min-width: 1904px) {
  .container {
    max-width: 90%;
  }
}
@media (max-width: 1260px) {
  .container {
    max-width: 90%;
  }
  .v-toolbar {
    left: 0px !important;
  }
  .v-main {
    padding-left: 0px !important;
  }
}
@media (max-width: 1024px) {
  .v-toolbar {
    left: 0px !important;
  }
  .v-main {
    padding-left: 0px !important;
  }
  .v-toolbar__title {
    display: none;
  }
  .logo {
    margin-right: 0;
  }
  .v-navigation-drawer {
    z-index: 6;
  }
  .pl20 {
    padding-left: 0% !important;
  }
  .ml3 {
    left: 0px !important;
  }
}
@media (max-width: 960px) {
  .container {
    max-width: 98%;
  }
  .logo {
    height: 30px;
  }
}
.forceIFrame {
  margin-bottom: 0 !important;
}
.iframeScroll {
  overflow-y: hidden !important;
}
@media (max-width: 599px) {
  .centerXsScreen {
    margin: 0 auto;
  }
}
@media only screen and (max-height: 750px) and (min-height: 520px) {
  .v-navigation-drawer {
    height: 45% !important;
  }
  .v-application--wrap {
    display: block;
  }
}
@media (max-width: 699px) {
  .v-navigation-drawer {
    height: calc(100% - 65px) !important;
  }
}
@media (max-height: 520px) {
  .v-application--wrap {
    display: block;
  }
}
#framefixerextreme {
  height: 0 !important;
  display: flex !important;
}
#framefixerextreme .v-application,
#framefixerextreme .v-application--wrap {
  height: 0 !important;
}
#framefixerextreme .v-application--wrap {
  display: block !important;
}
.active-custom, .no-active-custom {
  color: rgba(0,0,0,.87) !important;
}
.active-custom .v-list-item__icon .v-icon, .no-active-custom .v-list-item__icon .v-icon {
  color: rgba(0,0,0,.54) !important;
}
.active-custom {
  background-color: #cccccc !important;
}
.active-custom .no-active-custom {
  background-color: rgb(241, 241, 241) !important;
}
.menuMain .v-list-group__header {
    margin-bottom: 0px !important;
}
.v-navigation-drawer__content .v-list--nav {
  padding: 0px !important;
}
.no-active-custom .v-list-item--active {
  border-bottom: none !important;
}
</style>

<style scoped>
.alertUnpaid {
  position: fixed;
  z-index: 99;
  width: max-content;
  left: 50%;
  transform: translate(-50%, 0);
  text-align: center;
  top: 0;
  margin-left: 160px;
}
.alertUnpaid a {
  font-size: 2em;
  color: #000;
}
.divLeftBorder {
  height: 100%;
    border-left: 1px solid rgba(0,0,0,.12);
    /*padding-bottom: 80px*/
}
  @media (max-width: 1263px) {
    .divLeftBorder {
      /*margin-top: 84px !important;*/
      padding-bottom: 80px;
      height: calc(100vh - 96px);
    }
  }
@media (max-width: 1260px) {
  .alertUnpaid {
    margin-left: 0;
  }
}
@media (max-width: 699px) {
  .alertUnpaid {
    width: 95%;
  }
  .alertUnpaid a {
    font-size: 20px;
  }
  .alertUnpaid p {
    font-size: 14px;
  }
  .alertUnpaid .v-icon {
    display: none;
  }
  #framefixerextreme {
    display: none;
  }
}
</style>
